<template>
  <v-dialog
    width="850"
    persistent
    transition="slide-x-transition"
    v-model="get_modal_fechamento_caixa"
  >
    <v-card style="overflow-x: hidden;" class="expande-horizontal wrap">
      <div class="expande-horizontal column windows-style">
        <v-list nav color="transparent" class="pa-0 ma-0 pt-0 pb-2">
          <v-list-item class="fonte">
            <v-avatar color="#333" dark class="mr-2">
              <v-icon color="#f2f2f2">mdi-cash-register</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="">
                Fechamento de caixa
              </v-list-item-title>
              <span class="fonte ml-0 fonteMini grey--text">
                Informe a situação do caixa com o montante recebido em cada
                forma de pagamento.
              </span>
            </v-list-item-content>
            <v-list-item-action>
            <!-- <v-list-item-action v-if="!dueBox()"> -->
              <v-avatar
                @click="fecha_modal_fechamento_caixa"
                style="cursor: pointer;"
                :color="$theme.primary"
                dark
                class="mr-2"
              >
                <v-icon color="black">
                  mdi-close
                </v-icon>
              </v-avatar>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>

      <div class="expande-horizontal windows-style-content wrap py-6 pb-0">
        <v-flex class="pa-3" xs12>
          <div
          id="print-html-report"
          class="cash-closing-print-document"
          style="width: 100%; padding: 0px; display: flex; flex-direction: column; flex-wrap: wrap;"
        >
          <div
            style="display: flex; justify-content: space-between; flex-direction: row; flex-wrap: nowrap; width: 100%;"
          >
            <img :style="`min-height: 55px !important; max-height: 55px !important;`" :src="getLoggedUser.tenant[0].profileImage" alt="" />
            <div style="display: flex; align-items: center; flex-direction: column; padding-right: 7px; padding-left: 7px; ">
              <span class="font-head-title">
                {{ getLoggedUser.tenant[0].nome }}
              </span>
              <span class="font-head-subtitle">
                CNPJ: {{ getLoggedUser.tenant[0].cnpj }}
              </span>
              <span
                v-if="getLoggedUser.tenant[0].address"
                class="font-head-subtitle"
              >
                {{ getLoggedUser.tenant[0].address.formatted_address }}
              </span>
              <span
                class="font-head-subtitle"
                v-if="getLoggedUser.tenant[0].phone"
              >
                {{ getLoggedUser.tenant[0].phone }}
              </span>
            </div>
            <div
              class="font-head-subtitle"
            >
            </div>
          </div>
          <div
            style="margin-top: 12px;display: flex; justify-content: center; flex-wrap: wrap; width: 100%;"
          >
            <span class="font-title">RELATÓRIO DE CAIXA</span>
          </div>
          <div
            style="padding: 6px; padding-left: 0px; padding-right: 0px; display: flex; width: 100%; flex-direction: column; flex-wrap: wrap; width: 100%;"
          >
            <div style="display: flex; width: 100%; margin-top: 4px;">
              <span class="font-head-title" style="margin-right: 6px;">
                Funcionário:
              </span>
              <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                <span class="font-head-subtitle">
                  {{ caixa.funcionario.nome }}
                </span>
              </div>
            </div>
          </div>

           <div
            style="margin-bottom: 12px; margin-top: 4px; flex-direction: column; display: flex; width: 100%;"
          >
            <table>
              <tr>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">DATA DE EMISSÃO</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">OBSERVAÇÕES</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Nº DO CAIXA</th>
              </tr>

              <tr>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ $moment().format("DD/MM/YYYY HH:mm") }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">{{ getLoggedUser.tenant[0].receipt_config.short_obs }}</span>
                </td>
                <td style="max-width: 70px; border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">{{ caixa.id_caixa }}</span>
                </td>
              </tr>
            </table>
          </div>

          <div style="margin-bottom: 12px; margin-top: 4px; flex-direction: column; display: flex; width: 100%;">
            <table>
              <tr>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Entradas</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Saídas</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Subtotal</th>
              </tr>

              <tr>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ $helper.formataSaldo(balance.entradas) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ $helper.formataSaldo(balance.saidas) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ $helper.formataSaldo(balance.total) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          
          <div style="margin-bottom: 12px; margin-top: 4px; flex-direction: column; display: flex; width: 100%;">
            <table>
              <tr>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Dinheiro</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Débito</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Crédito</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Pix</th>
              </tr>

              <tr>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    💵 {{ $helper.formataSaldo(reportValues.total_entrada_dinheiro) }} / 📤 {{ $helper.formataSaldo(reportValues.total_saida_dinheiro) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    💵 {{ $helper.formataSaldo(reportValues.total_entrada_debito) }} / 📤 {{ $helper.formataSaldo(reportValues.total_saida_debito) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    💵 {{ $helper.formataSaldo(reportValues.total_entrada_credito) }} / 📤 {{ $helper.formataSaldo(reportValues.total_saida_credito) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    💵 {{ $helper.formataSaldo(reportValues.total_entrada_pix) }} / 📤 {{ $helper.formataSaldo(reportValues.total_saida_pix) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>

          <div
            style="display: flex; width: 100% !important; margin-top: 6px; margin-bottom: 6px; padding: 0px;"
          >
            <table
              style="width: 100% !important; background: #f0f0f0;"
            >
              <template>
                  <tr
                    class="tr-table"
                    style="width: 100%; background: #f7f7f7; border: 1px solid #f0f0f0;"
                  >
                    <!-- <td
                      style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        ORIGEM
                      </span>
                    </td> -->
                    <td
                      style="background: #e2e0e0; padding-right: 10px; padding-left: 10px; color: #333; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        ORIGEM
                      </span>
                    </td>
                    <td
                      style="background: #e2e0e0; padding-right: 10px; padding-left: 10px; color: #333; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        VALOR
                      </span>
                    </td>
                    <td
                      style="background: #e2e0e0; padding-right: 10px; padding-left: 10px; color: #333; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        TIPO
                      </span>
                    </td>
                    <td
                      style="background: #e2e0e0; padding-right: 10px; padding-left: 10px; color: #333; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        OBS
                      </span>
                    </td>
                    <td
                      style="background: #e2e0e0;padding-right: 10px; padding-left: 10px; color: #333; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        DATA/HORA
                      </span>
                    </td>
                  </tr>
                  <template v-for="(item, i2) in transactionsProcesseds">
                    <tr
                      style="background: #f2f2f2; border-bottom: 3px dashed #cccaca;"
                      :key="`desc-perso-${i2}`"
                    >
                      <td
                        class="fonte fonte-micro"
                        style="color: #333; padding-right: 10px; padding-left: 10px;"
                      >
                        <span v-if="item.origem" class="text-uppercase font-head-subtitle">
                          {{ item.origem }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="color: #333;padding-right: 10px; padding-left: 10px;"
                      >
                        <span class="font-head-title">
                          {{
                            $helper.formataSaldo(item.valor)
                          }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="color: #333;padding-right: 10px; padding-left: 10px;"
                      >
                        {{
                          item.tipo
                        }}
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="font-size: 10pt !important; color: #333;padding-right: 10px; padding-left: 10px;"
                      >
                        {{
                          item.obs
                        }}
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="font-size: 9pt !important; color: #666 !important;padding-right: 10px; padding-left: 10px;"
                      >
                          {{ $moment(item.data).format("DD/MM/YYYY HH:mm") }}
                      </td>
                    </tr>
                  </template>
              </template>
            </table>
          </div>

          <div
            style="color: #bebcbc; margin-top: 36px; display: flex; width: 100%; justify-content: center;"
          >
            _________________________________________________________________
          </div>
          <div
            style="display: flex; width: 100%; justify-content: center;"
          >
            <span class="font-head-title">
              {{ caixa.funcionario.nome }}
            </span>
          </div>
        </div>
         <v-flex xs12>
          <v-form v-if="false" ref="form">
            <div class="expande-horizontal wrap">

              <v-flex class="px-3" xs3>
                <v-text-field
                  v-model="get_caixa.dinheiro_cego"
                  label="Total em dinheiro"
                  placeholder="ex: 17,40"
                  prefix="R$"
                  v-mask="[
                    '#,#',
                    '#,##',
                    '##,##',
                    '###,##',
                    '####,##',
                    '#####,##'
                  ]"
                  outlined
                  @keyup.enter.prevent="fechar_caixa"
                  :color="$theme.primary"
                ></v-text-field>
              </v-flex>
              <v-flex class="px-3" xs3>
                <v-text-field
                  v-model="get_caixa.debito_cego"
                  label="Total em débito"
                  outlined
                  placeholder="ex: 175,00"
                  prefix="R$"
                  v-mask="[
                    '#,#',
                    '#,##',
                    '##,##',
                    '###,##',
                    '####,##',
                    '#####,##'
                  ]"
                  @keyup.enter.prevent="fechar_caixa"
                  :color="$theme.primary"
                ></v-text-field>
              </v-flex>
              <v-flex class="px-3" xs3>
                <v-text-field
                  v-model="get_caixa.credito_cego"
                  label="Total no crédito"
                  outlined
                  prefix="R$"
                  placeholder="ex: 1375,00"
                  v-mask="[
                    '#,#',
                    '#,##',
                    '##,##',
                    '###,##',
                    '####,##',
                    '#####,##'
                  ]"
                  @keyup.enter.prevent="fechar_caixa"
                  :color="$theme.primary"
                ></v-text-field>
              </v-flex>
              <v-flex class="px-3" xs3>
                <v-text-field
                  v-model="get_caixa.pix_cego"
                  label="Total no píx"
                  placeholder="ex: 13575,00"
                  outlined
                  prefix="R$"
                  v-mask="[
                    '#,#',
                    '#,##',
                    '##,##',
                    '###,##',
                    '####,##',
                    '#####,##'
                  ]"
                  @keyup.enter.prevent="fechar_caixa"
                  :color="$theme.primary"
                ></v-text-field>
              </v-flex>
            </div>
          </v-form>
        </v-flex>
        </v-flex>
        <!-- <v-btn
          rounded
          class="elevation-0 ml-3 mb-3"
          dark
          :color="$theme.primary"
          @click="fechar_caixa"
        >
          <span class="fonte"> Fechar Caixa </span>
        </v-btn> -->
        <v-btn
          rounded
          class="elevation-0 ml-3 mb-3"
          dark
          :color="$theme.primary"
          @click="ImprimirRelatorio"
        >
          <span class="fonte"> Imprimir Relatório e fechar caixa </span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "get_modal_fechamento_caixa", 
      "get_caixa", 
      "get_caixas",
      "getLoggedUser"
    ]),
    balance() {
      const total =
        this.reportValues.total_entrada_dinheiro +
        this.reportValues.total_entrada_pix +
        this.reportValues.total_entrada_debito +
        this.reportValues.total_entrada_credito -
        this.reportValues.total_saida_dinheiro -
        this.reportValues.total_saida_pix -
        this.reportValues.total_saida_debito -
        this.reportValues.total_saida_credito
      const entradas = this.reportValues.total_entrada_dinheiro +
        this.reportValues.total_entrada_pix +
        this.reportValues.total_entrada_debito +
        this.reportValues.total_entrada_credito
      const saidas = this.reportValues.total_saida_dinheiro +
        this.reportValues.total_saida_pix +
        this.reportValues.total_saida_debito +
        this.reportValues.total_saida_credito
      return { total, entradas, saidas }
    },
    reportValues() {
      let total_entrada_dinheiro = 0;
      let total_entrada_pix = 0;
      let total_entrada_debito = 0;
      let total_entrada_credito = 0;

      let total_saida_dinheiro = 0;
      let total_saida_pix = 0;
      let total_saida_debito = 0;
      let total_saida_credito = 0;

      let total_saida_dinheiro_aprovado = 0;
      let total_saida_pix_aprovado = 0;
      let total_saida_debito_aprovado = 0;
      let total_saida_credito_aprovado = 0;

      let total_saida_dinheiro_cancelado = 0;
      let total_saida_pix_cancelado = 0;
      let total_saida_debito_cancelado = 0;
      let total_saida_credito_cancelado = 0;
      
      let total_entrada_dinheiro_aprovado = 0;
      let total_entrada_pix_aprovado = 0;
      let total_entrada_debito_aprovado = 0;
      let total_entrada_credito_aprovado = 0;

      let total_entrada_dinheiro_cancelado = 0;
      let total_entrada_pix_cancelado = 0;
      let total_entrada_debito_cancelado = 0;
      let total_entrada_credito_cancelado = 0;

      const processPayment = payment => {
        switch (payment.payment_form) {
          case "pix":
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_receive') {
              total_entrada_pix += payment.total_without_taxs;
            }
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_pay') {
              total_saida_pix += payment.total_without_taxs;
            }
            if (payment.origin === 'sale') {
              total_entrada_pix += payment.total_without_taxs;
            }
            if (payment.origin === 'stock' && payment.path === 'stock-in') {
              total_saida_pix += payment.total_without_taxs;
            }
            break;
          case "dinheiro":
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_receive') {
              total_entrada_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_pay') {
              total_saida_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'sale') {
              total_entrada_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'stock' && payment.path === 'stock-in') {
              total_saida_dinheiro += payment.total_without_taxs;
            }
            break;
          case "debito":
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_receive') {
              total_entrada_debito += payment.total_without_taxs;
            }
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_pay') {
              total_saida_debito += payment.total_without_taxs;
            }
            if (payment.origin === 'sale') {
              total_entrada_debito += payment.total_without_taxs;
            }
            if (payment.origin === 'stock' && payment.path === 'stock-in') {
              total_saida_debito += payment.total_without_taxs;
            }
            break;
          case "credito":
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_receive') {
              total_entrada_credito += payment.total_without_taxs;
            }
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_pay') {
              total_saida_credito += payment.total_without_taxs;
            }
            if (payment.origin === 'sale') {
              total_entrada_credito += payment.total_without_taxs;
            }
            if (payment.origin === 'stock' && payment.path === 'stock-in') {
              total_saida_credito += payment.total_without_taxs;
            }
            break;
          default:
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_receive') {
              total_entrada_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'invoice' && payment.charge.invoice_type === 'to_pay') {
              total_saida_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'sale') {
              total_entrada_dinheiro += payment.total_without_taxs;
            }
            if (payment.origin === 'stock' && payment.path === 'stock-in') {
              total_saida_dinheiro += payment.total_without_taxs;
            }
            break;
        }
      };
      if (this.caixa.transactions) {
        this.caixa.transactions.map(transaction =>
          processPayment(transaction)
        );
      }
      return {
        total_entrada_dinheiro,
        total_entrada_pix,
        total_entrada_debito,
        total_entrada_credito,
        total_saida_dinheiro,
        total_saida_pix,
        total_saida_debito,
        total_saida_credito,
      };
    },
    transactionsProcesseds() {
      const formato = {
        origem: "",
        valor: "",
        tipo: "", //entrada ou saída
        data: "",
        obs: ""
      }
      if (this.transactions.length) {
        const res = this.transactions.map(transaction => {
          if (transaction.origin == 'sale') {
            const compra = transaction.sale.compra;
            const cliente = compra.cliente ? compra.cliente.nome : '';
            return {
              origem: "VENDA",
              valor: transaction.total_without_taxs,
              tipo: 'entrada',
              data: transaction.created_at,
              obs:  cliente
            }
          }

          if (transaction.origin == 'invoice' && transaction.charge.invoice_type == 'to_pay') {
            return {
              origem: "FATURA",
              valor: transaction.total_without_taxs,
              tipo: 'saída',
              data: transaction.created_at,
              obs: transaction.invoice.description || ''
            }
          }
          
          if (transaction.origin == 'invoice' && transaction.charge.invoice_type == 'to_receive') {
            return {
              origem: "FATURA",
              valor: transaction.total_without_taxs,
              tipo: 'entrada',
              data: transaction.created_at,
              obs: transaction.invoice.description || ''
            }
          }

          if (transaction.origin == 'stock' && transaction.path == 'stock-in') {
            return {
              origem: "ESTOQUE",
              valor: transaction.total_without_taxs,
              tipo: 'saída',
              data: transaction.created_at,
              obs: 'Compra de '+transaction.stock.quantidade + transaction.stock.unidade_de_medida.valor + ' de ' + transaction.stock.produto.nome || ''
            }
          }

        });
        const res2 = res.filter(t => !!t);
        console.log('res', res2)
        return res2
      } else {
        return []
      }
    }
  },
  data() {
    return {
      transactions: [],
      caixa: {
        funcionario: {}
      },
    }
  },
  watch: {
    get_modal_fechamento_caixa(val) {
      if (val) {
        this.listTransactions();
      }
    }
  },
  methods: {
    ...mapActions([
      "listarMeuCaixa",
      "fechar_caixa",
      "fecha_modal_fechamento_caixa"
    ]),
    dueBox() {
      if (this.get_caixa.status_atual === "aberto") {
        const dueDate = this.$moment().isAfter(
          this.$moment(this.get_caixa.created_at)
            .add(1, "days")
            .format()
        );
        if (this.get_caixa.status_atual == "aberto" && dueDate) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    listTransactions() {
      this.$store.dispatch("enableLoading");
      this.$run('box/view', { id: this.get_caixa._id }).then(res => {
        this.transactions = res.data.transactions
        this.caixa = res.data
        this.$store.dispatch("disableLoading");
      });
    },
    ImprimirRelatorio(compra) {
      // this.in_printing = true;
      this.showTemplate = true;
      this.lastSell = compra;
      var janelaImprimir = window.open("", "", "width=600,height=600");
      setTimeout(() => {
        janelaImprimir.document.open();
        janelaImprimir.document.write(
          "<html><head><title>Relatório de Caixa</title>"
        );
        janelaImprimir.document.write('<meta charset="utf-8">')
        const linkPreconnect = document.createElement("link");
        linkPreconnect.rel = "stylesheet";
        linkPreconnect.type = "text/css";
        linkPreconnect.href = "https://fonts.googleapis.com";
        linkPreconnect.crossOrigin = true;

        const linkPreconnect2 = document.createElement("link");
        linkPreconnect2.rel = "stylesheet";
        linkPreconnect2.type = "text/css";
        linkPreconnect2.href = "https://fonts.gstatic.com";

        const linkFonts = document.createElement("link");
        linkFonts.rel = "stylesheet";
        linkFonts.type = "text/css";
        linkFonts.href = "https://fonts.googleapis.com/css2?family=Arsenal:wght@400;700&family=Chakra+Petch:wght@600&display=swap"
        linkFonts.crossOrigin = true;

        janelaImprimir.document.head.appendChild(linkPreconnect);
        janelaImprimir.document.head.appendChild(linkPreconnect2);
        janelaImprimir.document.head.appendChild(linkFonts);

        janelaImprimir.document.write("<style>");
        janelaImprimir.document.write("table { width: 100%; }");
        janelaImprimir.document.write("body { -webkit-print-color-adjust: exact; }");
        janelaImprimir.document.write(".tr-table { border: 1px solid #333; margin: 0px; }");
        janelaImprimir.document.write(".bg-texts { font-weight: bold !important; background-color: #302b63 !important; border-radius: 3px; padding: 3px; padding-right: 6px; padding-left: 6px; color: #fff !important; }");
        janelaImprimir.document.write(".font-head-title { font-size: 14pt; font-weight: bold; font-family: 'Arsenal', sans-serif; color: #333; }");
        janelaImprimir.document.write(".font-head-subtitle { font-size: 12pt; font-family: 'Arsenal', sans-serif; color: #666; }");
        janelaImprimir.document.write(".font-title { font-size: 20pt; font-weight: bold; font-family: 'Chakra Petch', sans-serif; color: #333; }");
        janelaImprimir.document.write("@page { size: A4; margin: 0.5cm; }");
        janelaImprimir.document.write("@media print { .bg-texts { background-color: #302b63 !important; } }");
        janelaImprimir.document.write("</style>");
        janelaImprimir.document.write(
          "</head><body>"
        );
        janelaImprimir.document.write('<div id="imprimir-conteudo">');
        janelaImprimir.document.write(
          document.getElementById("print-html-report").innerHTML
        );
        janelaImprimir.document.write("</div>");
        janelaImprimir.document.write("</body></html>");
        janelaImprimir.document.close();
        janelaImprimir.focus(); // necessary for IE >= 10*/
        janelaImprimir.onload = () => {
          this.fechar_caixa(this.get_caixa._id);
          janelaImprimir.print();
          if (this.$vuetify.breakpoint.lgAndUp) {
            janelaImprimir.close();
            this.showTemplate = false;
          }
        };
      }, 200);
    },
  }
};
</script>

<style scoped>
#print-html-report.cash-closing-print-document {
  background: #ffffff !important;
  color: #333333 !important;
  border-radius: 4px;
  padding: 18px !important;
}

#print-html-report.cash-closing-print-document,
#print-html-report.cash-closing-print-document * {
  color: #333333 !important;
  border-color: #e2e0e0 !important;
}

#print-html-report.cash-closing-print-document table {
  background: #f0f0f0 !important;
  border-collapse: collapse;
  color: #333333 !important;
}

#print-html-report.cash-closing-print-document th,
#print-html-report.cash-closing-print-document tr[style],
#print-html-report.cash-closing-print-document td[style*="background"] {
  background: #e2e0e0 !important;
  color: #333333 !important;
}

#print-html-report.cash-closing-print-document tr:not(:first-child),
#print-html-report.cash-closing-print-document td {
  background: #f7f7f7 !important;
}

#print-html-report.cash-closing-print-document .font-head-subtitle {
  color: #666666 !important;
}
</style>
